import React from 'react';
import TreatmentTemplatesPanel from '../TreatmentTemplatesPanel';

interface Props {
  token: string;
}

export default function TreatmentsManagementPage({ token }: Props) {
  return <TreatmentTemplatesPanel token={token} />;
}
